const o=(o,s,t)=>{const p=s,r=o-1,u=o+1+1,e=[],h=[];let n;for(let o=1;o<=p;o++)(1===o||o===p||o>=r&&o<u)&&e.push(o);for(const o of e)n&&(o-n==2?h.push(n+1):o-n!=1&&h.push(t)),h.push(o),n=o;return h};export{o as buildSequenceOfPages};
